import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Image from '../WhyHostFormBlock1/Image';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';

import messages from '../../../../locale/messages';
import submit from './submit';
import validate from './validate';

import s from './WhyHostFormBlock4.css';
import cs from '../../../../components/commonStyle.css';

class WhyHostFormBlock4 extends Component {
  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, workImage1, workImage2, workImage3, workImage1Loader, workImage2Loader, workImage3Loader, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['easyHostTitle1', 'easyHostContent1', 'easyHostContent2', 'workTitle1', 'workTitle2', 'workContent1', 'workContent2', 'workTitleHeading'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={s.headerTitle}><FormattedMessage {...messages.WhyBecomeOwnerBlock4} /></h1>
            <form onSubmit={handleSubmit((values) => {
              const payload = { ...values, ...formValues };
              console.log('🚀 [WhyHostFormBlock4] Sending:', payload);
              return submit(payload, dispatch);
            })}>
              {hiddenFields}
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.easyHostTitle} /> 1</label>
                <MultiLanguageInput
                  baseField="easyHostTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleLabel1} /></label>
                <MultiLanguageInput
                  baseField="easyHostContent1"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleContentLabel1} /></label>
                <MultiLanguageInput
                  baseField="easyHostContent2"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /> 1</label>
                  <Image image={workImage1} fieldName={"workImage1"} loader={workImage1Loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleLabel2} /></label>
                <MultiLanguageInput
                  baseField="workTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleContentLabel2} /></label>
                <MultiLanguageInput
                  baseField="workContent1"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew}><FormattedMessage {...messages.imageLabel} /> 2</label>
                  <Image image={workImage2} fieldName={"workImage2"} loader={workImage2Loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleLabel3} /></label>
                <MultiLanguageInput
                  baseField="workTitle2"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleContentLabel3} /></label>
                <MultiLanguageInput
                  baseField="workContent2"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /> 3</label>

                  <Image image={workImage3} fieldName={"workImage3"} loader={workImage3Loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.noMargin}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                    <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                      <FormattedMessage {...messages.save} />
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

WhyHostFormBlock4 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock4);

const selector = formValueSelector('WhyHostForm');

const textFields = ['easyHostTitle1', 'easyHostContent1', 'easyHostContent2', 'workTitle1', 'workContent1', 'workTitle2', 'workContent2'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  
  return {
    formValues,
    workImage1Loader: state?.loader?.workImage1,
    workImage2Loader: state?.loader?.workImage2,
    workImage3Loader: state?.loader?.workImage3,
    workImage1: selector(state, 'workImage1'),
    workImage2: selector(state, 'workImage2'),
    workImage3: selector(state, 'workImage3'),
  };
};

const mapDispatch = {};

export default compose(
  withStyles(s, cs),
  injectIntl,
  connect(mapState, mapDispatch)
)(WhyHostFormBlock4);